var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f99d1f;}.cls-3{fill:url(#radial-gradient);}.cls-4{fill:url(#radial-gradient-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 13.12,
    cy: 6.42,
    r: 10.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e65b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e86417"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ef7c1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a01f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 11.42,
    cy: 8.74,
    r: 12.45,
    gradientTransform: "matrix(-0.88, -0.48, 0.4, -0.74, 26.69, 24.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d44510",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#d34510",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#cf4310",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c9410f",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#c13f0e",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#b53b0d",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#a7360c",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#97310b",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c2d0a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16,
    cy: 10,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 16,
    cy: 10,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 16,
    cy: 10,
    r: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.8ba7537684bfc608c7f97a73cccef9be.svg";
export { ForwardRef as ReactComponent };